import "./PricingSection.css";

function PricingSection({
  formData,
  updateField,
}) {
  const price = Number(formData.price || 0);
  const offerPrice = Number(formData.offerPrice || 0);

  const discount =
    price > 0 && offerPrice > 0
      ? Math.round(((price - offerPrice) / price) * 100)
      : 0;

  return (
    <div className="food-form-section">

      <h3 className="section-title">
        Pricing
      </h3>

      <div className="pricing-grid">

        {/* Price */}

        <div className="form-group">

          <label>
            Price (₹) *
          </label>

          <input
            type="number"
            min="1"
            placeholder="Enter Price"
            value={formData.price}
            onChange={(e) =>
              updateField("price", e.target.value)
            }
          />

        </div>

        {/* Offer Price */}

        <div className="form-group">

          <label>
            Offer Price (₹)
          </label>

          <input
            type="number"
            min="0"
            placeholder="Offer Price"
            value={formData.offerPrice}
            onChange={(e) =>
              updateField(
                "offerPrice",
                e.target.value
              )
            }
          />

        </div>

      </div>

      {discount > 0 && (
        <div className="discount-card">

          <h4>
            Customer Saves
          </h4>

          <span>
            {discount}% OFF
          </span>

        </div>
      )}

    </div>
  );
}

export default PricingSection;